import { axiosGet, axiosPost } from "./apiClient";

const BASE_URL = `${process.env.REACT_APP_BASE_URL}/adminusers`;

const getAssignedBranches = async ({ userId }) => {
    return await axiosGet(`${BASE_URL}/assigned-branches`, { userId });
};

const saveAssignedBranches = async ({ userId, branchIds }) => {
    return await axiosPost(`${BASE_URL}/assigned-branches/save`, {
        userId,
        branchIds,
    });
};

const adminUserBranchApi = {
    getAssignedBranches,
    saveAssignedBranches,
};

export default adminUserBranchApi;